module.exports = __webpack_public_path__ + "img/msgr-paul.3c4e28b3.jpg";